/* Kestran storefront — header, cart drawer, product form, sticky bar, reveal */
(function () {
  'use strict';
  var K = window.kestran || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = K.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    var amount = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withComma);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function imgUrl(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------------- header panels ---------------- */
  var panelBtns = $$('[data-k-panel]');
  var openPanel = null;
  function closePanels() {
    panelBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    $$('.k-panel').forEach(function (p) { p.classList.remove('is-open'); });
    openPanel = null;
  }
  panelBtns.forEach(function (btn) {
    var id = btn.getAttribute('data-k-panel');
    var panel = document.getElementById(id);
    if (!panel) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = openPanel === id;
      closePanels();
      if (!isOpen) { panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); openPanel = id; }
    });
    var t;
    btn.addEventListener('mouseenter', function () {
      if (window.matchMedia('(hover: hover)').matches) { clearTimeout(t); closePanels(); panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); openPanel = id; }
    });
    panel.addEventListener('mouseleave', function () { t = setTimeout(closePanels, 180); });
    panel.addEventListener('mouseenter', function () { clearTimeout(t); });
  });
  document.addEventListener('click', function (e) { if (openPanel && !e.target.closest('.k-panel')) closePanels(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanels(); closeMenu(); closeCart(); } });

  /* ---------------- mobile menu ---------------- */
  var menu = $('#KMobileMenu');
  function openMenu() { if (!menu) return; menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); document.body.classList.add('k-lock'); }
  function closeMenu() { if (!menu || !menu.classList.contains('is-open')) return; menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.body.classList.remove('k-lock'); }
  $$('[data-k-mmenu-open]').forEach(function (b) { b.addEventListener('click', openMenu); });
  $$('[data-k-mmenu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });

  /* ---------------- cart drawer ---------------- */
  var drawer = $('#KCartDrawer');
  var linesEl = drawer && $('[data-k-lines]', drawer);
  var footEl = drawer && $('[data-k-foot]', drawer);
  var emptyHTML = linesEl ? linesEl.innerHTML : '';

  function setCount(n) {
    $$('[data-k-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  /* free-shipping progress (no fake timers) */
  function updateWin(cart) {
    if (!drawer) return;
    var min = (K && K.freeShipMin) || 6000;
    var total = cart ? cart.total_price : 0;
    var t = $('[data-k-win-title]', drawer), sub = $('[data-k-win-sub]', drawer), bar = $('[data-k-win-bar]', drawer), w = $('[data-k-win]', drawer);
    var pct = Math.max(0, Math.min(100, Math.round(total / min * 100)));
    if (bar) bar.style.width = pct + '%';
    if (t) t.textContent = total >= min ? 'You unlocked free shipping' : 'Free shipping on 3+ bottles';
    if (sub) sub.textContent = total >= min ? 'Plus your free Sun-Worn Skin Guide.' : 'Your free Sun-Worn Skin Guide is included with every order.';
    if (w) w.classList.toggle('is-done', total >= min);
  }
  function openCart() {
    if (!drawer) { window.location.href = K.cartUrl || '/cart'; return; }
    closeMenu();
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('k-lock');
    
    var p = $('.k-drawer__panel', drawer); if (p) setTimeout(function () { p.focus(); }, 50);
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('k-lock');

  }
  if (drawer) $$('[data-k-close]', drawer).forEach(function (b) { b.addEventListener('click', closeCart); });
  $$('[data-k-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); refreshCart().then(openCart); });
  });

  function renderCart(cart) {
    setCount(cart.item_count);
    updateWin(cart);
    if (!linesEl) return;
    if (!cart.item_count) { linesEl.innerHTML = emptyHTML; if (footEl) footEl.hidden = true; return; }
    var html = cart.items.map(function (it, i) {
      var line = i + 1;
      var plan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : (it.variant_title || 'One-time purchase');
      var orig = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="k-line">' +
        '<a class="k-line__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div><a class="k-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<div class="k-line__plan">' + esc(plan) + '</div>' +
        '<div class="k-line__row"><div class="k-qty"><button type="button" data-k-line="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-k-line="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '<span class="k-line__price">' + orig + money(it.final_line_price) + '</span></div>' +
        '<button type="button" class="k-line__remove" data-k-line="' + line + '" data-q="0">Remove</button>' +
        '</div></div>';
    }).join('');
    linesEl.innerHTML = html;
    if (footEl) { footEl.hidden = false; var t = $('[data-k-total]', footEl); if (t) t.textContent = money(cart.total_price); }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }).catch(function () {});
  }
  function changeLine(line, qty) {
    if (linesEl) linesEl.style.opacity = '.55';
    return fetch((K.cartChangeUrl || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); }).finally(function () { if (linesEl) linesEl.style.opacity = ''; });
  }
  if (linesEl) {
    linesEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-k-line]');
      if (b) { changeLine(parseInt(b.getAttribute('data-k-line'), 10), Math.max(0, parseInt(b.getAttribute('data-q'), 10))); return; }
    });
  }

  function addToCart(payload) {
    return fetch((K.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [payload] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.'); return j; });
    });
  }

  /* ---------------- product form ---------------- */
  var form = $('[data-k-form]');
  if (form) {
    var atc = $('[data-k-atc]', form);
    var err = $('[data-k-error]', form);

    var opts = $$('[data-k-opt]');
    var stickyPrice = $('[data-k-sticky-price]');
    function syncOpt() {
      opts.forEach(function (o) {
        var r = $('input', o); o.classList.toggle('is-selected', r.checked);
        if (r.checked) {
          form.querySelector('input[name="selling_plan"]').value = r.value;
          form.querySelector('input[name="quantity"]').value = r.getAttribute('data-qty') || 1;
          if (stickyPrice) stickyPrice.textContent = r.getAttribute('data-sticky');
        }
      });
    }
    opts.forEach(function (o) { $('input', o).addEventListener('change', syncOpt); });
    if (opts.length && !opts.some(function (o) { return $('input', o).checked; })) {
      var wrap = $('[data-k-first]'); var first = wrap && wrap.getAttribute('data-k-first');
      var pick = opts.filter(function (o) { return $('input', o).value === first; })[0] || opts[0];
      $('input', pick).checked = true;
    }
    syncOpt();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (err) { err.classList.remove('is-visible'); err.textContent = ''; }
      atc.classList.add('is-loading');
      var payload = { id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1 };
      var plan = form.querySelector('input[name="selling_plan"]');
      if (plan && plan.value) payload.selling_plan = parseInt(plan.value, 10);
      addToCart(payload).then(refreshCart).then(openCart).catch(function (ex) {
        if (err) { err.textContent = ex.message; err.classList.add('is-visible'); }
      }).finally(function () { atc.classList.remove('is-loading'); });
    });

    /* sticky bar */
    var sticky = $('[data-k-sticky]');
    var sBtn = $('[data-k-sticky-btn]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(atc);
    }
    if (sBtn) sBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
  }

  /* ---------------- gallery dots (mobile) ---------------- */
  var gal = $('[data-k-gallery]');
  var dots = $$('[data-k-dots] i');
  if (gal && dots.length) {
    gal.addEventListener('scroll', function () {
      var items = gal.children; if (!items.length) return;
      var w = items[0].getBoundingClientRect().width + 10;
      var idx = Math.round(gal.scrollLeft / w);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }, { passive: true });
  }

  /* ---------------- reveal ---------------- */
  var rev = $$('.k-reveal');
  if ('IntersectionObserver' in window && rev.length) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    rev.forEach(function (el) { ro.observe(el); });
  } else { rev.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------------- swipe carousels + dots (mobile) ---------------- */
  $$('[data-k-carousel]').forEach(function (track) {
    var dotsEl = track.parentNode.querySelector('[data-k-cdots]');
    var items = Array.prototype.slice.call(track.children);
    if (!dotsEl || items.length < 2) return;
    dotsEl.innerHTML = items.map(function (_, i) { return '<button type="button" aria-label="Slide ' + (i + 1) + '"' + (i === 0 ? ' class="is-active"' : '') + '></button>'; }).join('');
    var btns = $$('button', dotsEl);
    function current() {
      var left = track.getBoundingClientRect().left, best = 0, bd = 1e9;
      items.forEach(function (it, i) { var d = Math.abs(it.getBoundingClientRect().left - left - parseFloat(getComputedStyle(track).paddingLeft || 0)); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var c = current(); btns.forEach(function (b, i) { b.classList.toggle('is-active', i === c); }); }, 60); }, { passive: true });
    btns.forEach(function (b, i) { b.addEventListener('click', function () { track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); }); });
  });

  /* ---------------- scroll-lit timeline ---------------- */
  $$('[data-k-steps]').forEach(function (wrap) {
    var steps = $$('.k-time__step', wrap);
    if (!('IntersectionObserver' in window)) { steps.forEach(function (s) { s.classList.add('is-lit'); }); return; }
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) en.target.classList.add('is-lit'); });
    }, { rootMargin: '-35% 0px -45% 0px' });
    steps.forEach(function (s) { so.observe(s); });
    wrap.classList.add('is-armed');
  });

  /* ---------------- parallax / slow zoom on scroll ---------------- */
  var px = $$('[data-k-parallax]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (px.length && !reduce) {
    var ticking = false;
    function paint() {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (vh - r.top) / (vh + r.height); p = Math.max(0, Math.min(1, p));
        el.style.setProperty('--k-p', p.toFixed(3));
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  /* ---------------- ambient product films (lazy, muted, looping) ---------------- */
  var vids = $$('video[data-k-vid]');
  var saveData = navigator.connection && navigator.connection.saveData;
  if (vids.length && !reduce && !saveData) {
    var mob = window.matchMedia('(max-width: 749px)').matches;
    function vLoad(v) {
      if (v.getAttribute('data-on')) return;
      var s = (mob && v.getAttribute('data-src-m')) || v.getAttribute('data-src');
      if (!s || !/^(https?:)?\/\//.test(s)) return;
      v.setAttribute('data-on', '1');
      v.muted = true; v.src = s;
      v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { vLoad(v); if (v.paused && v.getAttribute('data-on')) { var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); } }
          else if (!v.paused) v.pause();
        });
      }, { rootMargin: '200px 0px' });
      vids.forEach(function (v) { if (v.hasAttribute('data-eager')) vLoad(v); vo.observe(v); });
    } else { vids.forEach(vLoad); }
  }

  /* ---------------- product gallery lightbox ---------------- */
  if (gal) {
    var imgs = $$('img', gal);
    var lb = document.createElement('div');
    lb.className = 'k-lb'; lb.setAttribute('aria-hidden', 'true'); lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Product images');
    lb.innerHTML = '<button type="button" class="k-lb__close" aria-label="Close">&times;</button><div class="k-lb__track"></div><div class="k-lb__thumbs"></div>';
    var lbTrack = $('.k-lb__track', lb), lbThumbs = $('.k-lb__thumbs', lb);
    imgs.forEach(function (im, i) {
      var src = im.currentSrc || im.src; var big = src.replace(/width=\d+/, 'width=1600');
      lbTrack.insertAdjacentHTML('beforeend', '<div class="k-lb__slide"><img src="' + esc(big) + '" alt="' + esc(im.alt) + '" loading="lazy"></div>');
      lbThumbs.insertAdjacentHTML('beforeend', '<button type="button" data-i="' + i + '"><img src="' + esc(src.replace(/width=\d+/, 'width=200')) + '" alt=""></button>');
    });
    document.body.appendChild(lb);
    var lbSlides = $$('.k-lb__slide', lb), lbBtns = $$('.k-lb__thumbs button', lb);
    function lbGo(i, smooth) { lbTrack.scrollTo({ left: lbSlides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' }); lbBtns.forEach(function (b, j) { b.classList.toggle('is-active', j === i); }); }
    function lbOpen(i) { lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.classList.add('k-lock'); requestAnimationFrame(function () { lbGo(i, false); }); }
    function lbClose() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.classList.remove('k-lock'); }
    imgs.forEach(function (im, i) { im.style.cursor = 'zoom-in'; im.addEventListener('click', function () { lbOpen(i); }); });
    lbBtns.forEach(function (b) { b.addEventListener('click', function () { lbGo(parseInt(b.getAttribute('data-i'), 10), true); }); });
    $('.k-lb__close', lb).addEventListener('click', lbClose);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('k-lb__slide')) lbClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) lbClose(); });
    var lt; lbTrack.addEventListener('scroll', function () { clearTimeout(lt); lt = setTimeout(function () { var i = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth); lbBtns.forEach(function (b, j) { b.classList.toggle('is-active', j === i); }); }, 80); }, { passive: true });
  }

  /* keep count fresh (e.g. after back navigation) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  if (drawer && drawer.getAttribute('data-autoload') !== 'false') refreshCart();

  window.KestranCart = { open: openCart, close: closeCart, refresh: refreshCart };
})();
